import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'
import { MemberService } from '../../services/member/member.service'
import { GlobalErrorService } from '@services/global-error.service'
import { CertificateCategory } from '@shared/models/certificate-category.model'

export function memberExistsValidator(
  memberService: MemberService,
  globalErrorService: GlobalErrorService,
  category: CertificateCategory,
  initialValue: string | null = null,
  debounceTimeMs?: number
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value as unknown

    if (typeof value !== 'string' || value.trim() === '') {
      return of(null)
    }

    const nameToCheck = value.trim()

    if (initialValue !== null && nameToCheck === initialValue.trim()) {
      return of(null)
    }

    return timer(debounceTimeMs ?? 300).pipe(
      switchMap(() => memberService.checkMemberExists(nameToCheck, category)),
      map(exists => (exists ? { memberExists: true } : null)),
      catchError(() => {
        globalErrorService.reportError({
          subsystemName: 'Member Validator',
          description: 'Could not validate if Member exists. Please try again.'
        })
        // Return null to prevent the form field from being marked as invalid due to a server error
        return of(null)
      }),
      first()
    )
  }
}
